// extracted by mini-css-extract-plugin
export default {"fontlarge":"1.5em","img":"info_img__51WGu","subTitle":"info_subTitle__mdjVg"};